<template>
  <div class="view-container">
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="handleClose">
      <el-form v-if="drawer" ref="form" label-position="top" :model="form" :disabled="openType=='view'" :rules="rules" label-width="160px" style="padding:16px;">
        <BjDivider>{{ $t('AddingAnInternalReturnRefundDoc.Basic') }} </BjDivider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.searchName')" prop="chargeItemCode">
              <el-input v-model="form.chargeItemCode" disabled :clearable="false"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.startDate')" prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('billingPage.startDate')"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <BjDivider  right-fixed>{{ $t('billingPage.historicalBB') }}
          <template slot="right">
            <el-button type="primary" v-if="form.position2b.length==0" @click="addPositionB">{{$t('addText')}}</el-button>
          </template>
        </BjDivider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.hisGeneral')" prop="costPrice2b">
              <BjInputNumber v-model="form.costPrice2b" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable ><template slot="append">$</template></BjInputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.hisTime')" prop="costMinute2b">
              <BjInputNumber v-model="form.costMinute2b" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable ><template slot="append">Mins</template></BjInputNumber>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(positionB, index) in form.position2b" :key="index">
<!--          <el-col :span="10">
            <el-form-item
              :label="$t('billingPage.position') + (index + 1)"
              :key="positionB.key"
              :prop="'position2b.' + index + '.name'"
              :rules="{
                required: true, message: $t('inputText'), trigger: 'blur'
              }"
            >
              <el-input v-model="positionB.name" :placeholder="$t('inputText')"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="10">
            <el-form-item :label="$t('billingPage.position') + (index + 1)">
              <BjSelectLov v-model="form.position2b[index]['name']" :option-list="departList" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              :label="$t('billingPage.hisPerce') + (index + 1)"
              :key="positionB.key"
              :prop="'position2b.' + index + '.percentage'"
              :rules="{
                required: true, message: $t('inputText'), trigger: 'blur'
              }"
            >
              <BjInputNumber v-model="positionB.percentage"><template slot="append">%</template></BjInputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-top: 28px;font-size: 25px;color: seagreen">
            <i @click="removePositionB(index)" class="el-icon-remove-outline"></i>
            <i @click="addPositionB()" class="el-icon-circle-plus-outline" style="margin-left: 18px;"></i>
          </el-col>
        </el-row>

        <BjDivider  right-fixed>{{ $t('billingPage.historicalCC') }}
          <template slot="right">
            <el-button type="primary" v-if="form.position2c.length==0" @click="addPositionC">{{$t('addText')}}</el-button>
          </template>
        </BjDivider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.hisGeneral')" prop="costPrice2c">
              <BjInputNumber v-model="form.costPrice2c" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable ><template slot="append">%</template></BjInputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.hisTime')" prop="costMinute2c">
              <BjInputNumber v-model="form.costMinute2c" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable ><template slot="append">Mins</template></BjInputNumber>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(positionC, index) in form.position2c" :key="index">
<!--          <el-col :span="10">
            <el-form-item
              :label="$t('billingPage.position') + (index + 1)"
              :key="positionC.key"
              :prop="'position2c.' + index + '.name'"
              :rules="{
                required: true, message: $t('inputText'), trigger: 'blur'
              }"
            >
              <el-input v-model="positionC.name" :placeholder="$t('inputText')"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="10">
            <el-form-item :label="$t('billingPage.position') + (index + 1)">
              <BjSelectLov v-model="form.position2c[index]['name']" :option-list="departList" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              :label="$t('billingPage.hisPerce') + (index + 1)"
              :key="positionC.key"
              :prop="'position2c.' + index + '.percentage'"
              :rules="{
                required: true, message: $t('inputText'), trigger: 'blur'
              }"
            >
              <BjInputNumber v-model="positionC.percentage"><template slot="append">%</template></BjInputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-top: 28px;font-size: 25px;color: seagreen">
            <i @click="removePositionC()" class="el-icon-remove-outline"></i>
            <i @click="addPositionC()" class="el-icon-circle-plus-outline" style="margin-left: 18px;"></i>
          </el-col>
        </el-row>
      </el-form>
      <div class="foot">
        <el-button type="danger" @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" :disabled="openType=='view'" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {userApi} from '@/api';

const getDefaultForm = () => {
  return {
    id: null,
    chargeItemCode: null,
    startDate: null,
    costPrice2b: null,
    costMinute2b: null,
    position2b: [{}],
    costPrice2c: null,
    costMinute2c: null,
    position2c: [{}],
  };
};
export default {
  data() {
    return {
      openType: 'view',
      // 表单参数
      drawer: false,
      form: getDefaultForm(),
      inputVisible: false,
      departList: [],
      // 表单校验
      rules: {
        chargeItemCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        startDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        costPrice2b: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        costMinute2b: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        costPrice2c: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        costMinute2c: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getDepOptions();
  },
  methods: {
    // 获取岗位下拉选项列表
    getDepOptions() {
      userApi.getStationPage({ size: 999, page: 0 }).then(res => {
        this.departList = res.content.map(item => {
          return {...item, label: `${item.department}>${item.position}`, value: `${item.department}>${item.position}`};
        });
      });
    },
    addPositionB() {
      this.form.position2b.push({
        name: '',
        percentage: '',
      });
    },
    removePositionB(index) {
      this.form.position2b.splice(index, 1)
    },
    addPositionC() {
      this.form.position2c.push({
        name: '',
        percentage: '',
      });
    },
    removePositionC(index) {
      this.form.position2c.splice(index, 1)
    },
    // 确定按钮
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const obj = Object.assign({}, this.form);
          this.$emit('handleConfirm', obj);
          this.hide();
        }
      });
    },
    // 弹窗关闭
    hide() {
      this.drawer = false;
      // this.$refs.form.resetFields();
    },
    /** 关闭弹窗 */
    handleClose() {
      this.hide();
      this.form = getDefaultForm();
    },
  },
};
</script>
<style lang="scss">
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
